import React, { Component } from "react"
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import $ from "jquery"
import moment from "moment";
import styles from "../../../../assets/jss/customStyle";
import withRouter from "../../../custom/withRouter";
import { gethistorylogdwprdocinfo } from "../../../../actions/DWPRAction"
import { getSettingsFormat } from "../../../../actions/SettingsAction";
class HistoryLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ProjectId: 0,
            isMobile: false,
            menu: true,
        }
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.ProjectId = localStorage.getItem("DashId")
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        dispatch(gethistorylogdwprdocinfo(this.state.ProjectId))
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const { isEdit } = this.state;
        let { classes, getprojectid, menuToggle, projectList } = this.props;
        return (
            <>
                <div className="row">
                    <div className="mt-n3">
                        <div className="col-sm-12 col-12 px-0">
                            <div className="table-responsive mb-4" style={{ width: "100%" }}>
                                <table id="dataTable" className="table">
                                    <thead>
                                        <tr className="">
                                            <th className="border-top border-right border-left" style={{ width: '15%', minWidth: '160px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Timestamp</span></th>
                                            <th className="border-top border-right" style={{ width: '10%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                            <th className="border-top border-right" style={{ width: '15%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Action by</span></th>
                                            <th className="border-top border-right" style={{ width: '60%', minWidth: window.innerWidth < 1000 ? '400px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Comments</span></th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ fontFamily: 'Segoe UI' }}>
                                        {this.props.historyLog && this.props.historyLog.map((i) => (
                                            <tr>
                                                <td className="spandoc-td border-right border-left align-middle Nowrap">
                                                {moment(i.TimeStamp).format(this.props.settings.Convention ? this.props.settings.Convention + " hh:mm:ss A" : "DD/MM/YYYY hh:mm:ss A")}
                                                    </td>
                                                <td className="spandoc-td border-right align-middle">{i.Action}</td>
                                                <td className="spandoc-td border-right align-middle">{i.ActionBy}</td>
                                                <td className="spandoc-td border-right align-middle">{i.Comments}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        historyLog: state.commonReducer.historyLog || [],
        settings: state.commonReducer.settings || [],
    };
}

// EditPBD-HistoryLog.propTypes = {
//     classes: PropTypes.object.isRequired,
// }

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HistoryLog))
);
